import React, {FC} from 'react';
import './style.scss';
import {useHistory} from 'react-router-dom';
import MixesCard from "../MixesCard";
import {IMix} from "../../constants/types";

interface IMixesList {
    mixes: Array<IMix>,
    setTobaccoIndex: any,
    pathUrl: string
}

const MixesList: FC<IMixesList> = ({
                                       mixes,
                                       setTobaccoIndex,
                                       pathUrl
                                   }) => {
    const history = useHistory();

    const clickHandler = (id: number) => {
        const mixIndex = mixes.findIndex((item: { id: number }) => item && item.id === id);
        setTobaccoIndex(mixIndex);
        history.push(pathUrl + mixIndex);
    };

    return (
        <div className="mixes-list">
            <div className="mixes-list__cards">
                {
                    mixes.map((item: IMix) => {
                        return (
                            <MixesCard
                                key={item.id}
                                id={item.id}
                                clickHandler={() => clickHandler(item.id)}
                                imageUrl={item.imageUrl}
                                name={item.name}
                                isLiked={item.isLiked}
                                likeCount={item.likeCount}
                            />
                        )
                    })
                }
            </div>
        </div>
    )
};

export default MixesList;
